
import {tracker} from "../tracker/global.js"

export const batch = tracker.batch

